import store from "../redux/store.ts";
import { app } from "./app";
import { apiActivity } from "../api/activity/apiActivity";
import { appSelectors } from "../redux/reducers/app.ts";
import { notifyError } from "shared/errors/notificate.ts";

export const activity = {
  getActivities: async (fromEvent) => {
    if (!fromEvent) {
      app.changePageContentLoaderStatus(true);
      app.changeTableContentLoaderStatus(true);
    }

    const oldRequest = appSelectors.errorRequest(store.getState());

    !oldRequest.activityQueue &&
      app.updateErrorRequest({
        activityQueue: true,
      });

    try {
      await apiActivity.getActivities();

      app.updateErrorRequest({
        activityQueue: false,
      });

      if (!fromEvent) {
        app.changePageContentLoaderStatus(false);
        app.changeTableContentLoaderStatus(false);
      }
    } catch (error) {
      notifyError(error);
      app.changePageContentLoaderStatus(false);
      app.changeTableContentLoaderStatus(false);
    }
  },
};
